import React from 'react';
import { Route } from 'react-router-dom';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import userManager from '../../utils/usermanager';
import LoadingSpinner from '../LoadingSpinner';

const PrivateRoute = ({ component: Component, user, location, ...rest }) => {
  const notLoggedIn = !user || user.expired === true;
  if (notLoggedIn) {
    userManager.signinRedirect({ state: location });
    return <LoadingSpinner />;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
};

const mapStateToProps = state => ({
  user: state.oidc.user,
  isLoadingUser: state.oidc.isLoadingUser,
});

export default connect(mapStateToProps)(PrivateRoute);
